import Html from "./html";
import { Provider } from "./provider";

const EditFtm = ({
    ftm_id,
    open,
    handleClose,
    handleSubmitClose,
    isApproveProcess = false,
}) => {
    return (
        <Provider
            ftm_id = {ftm_id}
            handleSubmitClose = {handleSubmitClose}
            children = {
                <Html
                    open = {open}
                    handleClose = {handleClose}
                    isApproveProcess = {isApproveProcess}
                />
            }
        />
    );
}

export default EditFtm;